module.exports = __webpack_public_path__ + "static/media/6@720w.8e6cf542.jpg";